import axios from 'axios';
import config from '../config/config';

const ADMIN_API_URL = `${config.api.baseUrl}/admin`;

const adminHeaders = (adminSecret) => ({
  'x-admin-secret': adminSecret || ''
});

export const getImageReviews = ({ adminSecret, status = 'pending', source = 'generated', type = '', q = '', limit = 50 } = {}) => {
  return axios.get(`${ADMIN_API_URL}/image-reviews`, {
    headers: adminHeaders(adminSecret),
    params: { status, source, type, q, limit }
  });
};

export const approveImageReview = ({ adminSecret, reviewId, provider }) => {
  return axios.post(
    `${ADMIN_API_URL}/image-reviews/${reviewId}/approve`,
    { provider },
    { headers: adminHeaders(adminSecret) }
  );
};

export const rejectImageReview = ({ adminSecret, reviewId }) => {
  return axios.post(
    `${ADMIN_API_URL}/image-reviews/${reviewId}/reject`,
    {},
    { headers: adminHeaders(adminSecret) }
  );
};

export const skipImageReview = ({ adminSecret, reviewId }) => {
  return axios.post(
    `${ADMIN_API_URL}/image-reviews/${reviewId}/skip`,
    {},
    { headers: adminHeaders(adminSecret) }
  );
};

export const confirmUnreliableImageReview = ({ adminSecret, reviewId }) => {
  return axios.post(
    `${ADMIN_API_URL}/image-reviews/${reviewId}/confirm-unreliable`,
    {},
    { headers: adminHeaders(adminSecret) }
  );
};

export const dismissReportedImageReview = ({ adminSecret, reviewId }) => {
  return axios.post(
    `${ADMIN_API_URL}/image-reviews/${reviewId}/dismiss-report`,
    {},
    { headers: adminHeaders(adminSecret) }
  );
};

export const getEarlyAccessWaitlist = ({ adminSecret, limit = 100 } = {}) => {
  return axios.get(`${ADMIN_API_URL}/early-access/waitlist`, {
    headers: adminHeaders(adminSecret),
    params: { limit },
  });
};

export const getEarlyAccessApprovals = ({ adminSecret, limit = 100 } = {}) => {
  return axios.get(`${ADMIN_API_URL}/early-access/approvals`, {
    headers: adminHeaders(adminSecret),
    params: { limit },
  });
};

export const approveEarlyAccessSubmission = ({ adminSecret, submissionId }) => {
  return axios.post(
    `${ADMIN_API_URL}/early-access/waitlist/${submissionId}/approve`,
    {},
    { headers: adminHeaders(adminSecret) }
  );
};

export const resetEarlyAccessUnlock = ({ adminSecret, approvalId }) => {
  return axios.post(
    `${ADMIN_API_URL}/early-access/approvals/${approvalId}/reset-unlock`,
    {},
    { headers: adminHeaders(adminSecret) }
  );
};

export const resendEarlyAccessApprovalEmail = ({ adminSecret, approvalId }) => {
  return axios.post(
    `${ADMIN_API_URL}/early-access/approvals/${approvalId}/resend-email`,
    {},
    { headers: adminHeaders(adminSecret) }
  );
};

export const getAnalyticsOverview = ({ adminSecret, filters = {} }) => {
  return axios.get(`${ADMIN_API_URL}/analytics/overview`, {
    headers: adminHeaders(adminSecret),
    params: filters
  });
};

export const searchAnalyticsUsers = ({ adminSecret, username = '', limit = 20 }) => {
  return axios.get(`${ADMIN_API_URL}/analytics/users/search`, {
    headers: adminHeaders(adminSecret),
    params: { username, limit }
  });
};

export const getAnalyticsUserJourney = ({ adminSecret, userId }) => {
  return axios.get(`${ADMIN_API_URL}/analytics/users/${userId}/journey`, {
    headers: adminHeaders(adminSecret)
  });
};

export const getAnalyticsCostAssumptions = ({ adminSecret }) => {
  return axios.get(`${ADMIN_API_URL}/analytics/cost-assumptions`, {
    headers: adminHeaders(adminSecret)
  });
};

export const createAnalyticsCostAssumption = ({ adminSecret, assumption }) => {
  return axios.post(
    `${ADMIN_API_URL}/analytics/cost-assumptions`,
    assumption,
    { headers: adminHeaders(adminSecret) }
  );
};
